import axios from 'axios';
import forEach from 'lodash/forEach';
import indexOf from 'lodash/indexOf';
import moment from 'moment';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';

import { adminUrl, DB_DATE_FORMAT } from '../config/constants';
import { BORROWER, MORTGAGE_BROKER, REALTOR } from '../constants/contact_id_status';
import { PURCHASE } from '../constants/pms_purpose_of_loan';
import {
  COMMERCIAL,
  CONSTRUCTION,
  FIX_FLIP,
  RESIDENTIAL,
  TDS,
} from '../constants/typeOfHomeOptions';

export const saveToCRM = () => async (dispatch, getState) => {
  dispatch({
    type: 'SET_LOADING',
    payload: true,
  });

  const { accounts, contacts } = getState().form;
  const { userId, isNewUser, userId2 } = getState().user;
  const { place_id, address } = getState().place;

  const consoleBrok1 = getState().consoleBrok1;

  let data = { ...consoleBrok1 };

  const compareTypeOfLoan = [RESIDENTIAL.value, COMMERCIAL.value, TDS.value];

  if (accounts.type_of_loan !== FIX_FLIP.value && accounts.type_of_loan !== CONSTRUCTION.value) {
    data.arv_market_value = '';
    data.rehab_amount = '';
    data.sq_ft_addition = '';
  } else if (indexOf(compareTypeOfLoan, accounts.type_of_loan) === -1) {
    data.property_income = '';
  }

  if (consoleBrok1.purpose_of_loan !== PURCHASE.value) {
    data.purchase_status = '';
    data.prchs_trnsctn_type = '';
  }

  const dateFields = ['purchase_date', 'coe_date'];

  const formData = new FormData();

  formData.append('action', 'saveLoan');

  if (contacts.id_status === BORROWER.value) {
    formData.append('borrower_name_id', userId);
  } else if (contacts.id_status === REALTOR.value) {
    formData.append('realtor_listing_agent_id', userId);
    formData.append('borrower_name_id', userId2);
  } else if (contacts.id_status === MORTGAGE_BROKER.value) {
    formData.append('mortgage_broker_id', userId);
    formData.append('borrower_name_id', userId2);
  }

  formData.append('type_of_loan', accounts.type_of_loan);
  formData.append('id_status', contacts.id_status);
  formData.append('isNewUser', isNewUser);

  forEach(data, (val, field) => {
    if (indexOf(dateFields, field) !== -1) {
      val = moment(val).format(DB_DATE_FORMAT);
    }

    formData.append(field, val);
  });

  if (place_id !== '') {
    const address_ = await geocodeByPlaceId(place_id);

    let street_num = '';
    let componentFields = {
      postal_code: 'short_name',
      //mailing address
      route: 'long_name',
      // city
      locality: 'long_name',
      // state
      administrative_area_level_1: 'long_name',

      //county
      administrative_area_level_2: 'long_name',
    };

    let formFields = {
      locality: 'property_address_city',
      postal_code: 'property_address_zipcode',
      route: 'property_address_street',
      administrative_area_level_1: 'property_address_state',
      administrative_area_level_2: 'property_address_county',
    };

    for (let i = 0; i < address_[0].address_components.length; i++) {
      let addressType = address_[0].address_components[i].types[0];

      if (addressType === 'street_number') {
        street_num = address_[0].address_components[i]['long_name'];
      }

      if (componentFields[addressType]) {
        let val = address_[0].address_components[i][componentFields[addressType]];

        if (street_num !== '' && addressType === 'route') {
          val = street_num + ' ' + val;
        }

        formData.append(formFields[addressType], val);
      }
    }

    formData.append('complete_address', address);
  }

  formData.append('online_app_created_date', moment().format(DB_DATE_FORMAT));

  await axios.post(adminUrl, formData);

  dispatch({
    type: 'SET_LOADING',
    payload: false,
  });

  window.location.href = window.globalObject_1['baseUrl'] + '/borrower-thank-you';
};



// WEBPACK FOOTER //
// ./src/actions/saveToCRM.actions.js